import styles from './style.module.scss';
import Modal from '../../components/Modal'
import { ShareSquareIcon } from '../../assets/icons'
import Button from '../../components/Button';
import { useDispatch } from '../../store/store';
import { setExamShareGuideModal } from '../../store/workspace/slice';

const img = require("../../assets/images/exam_share_guide.png");

export default function ExamShareGuide() {
    const dispatch = useDispatch();

    return (
        <Modal
            size='lg'
            title='Share exam link'
            icon={<ShareSquareIcon />}
            childClassName={styles.wrapper}
        >
            <img src={img} alt="" />
            <p>
                Interviews and exams have been successfully
                generated for your job posting. Click "Exam Share Link"
                on the job card to share the job link with potential applicants.
            </p>
            <div className={styles.actions}>
                <Button
                    text='Ok'
                    type='Primary'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setExamShareGuideModal(false))}
                />
            </div>
        </Modal>
    )
}
